import { comics } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function LatestUpdates() {
  const latest = [...comics].sort(
    (a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()
  );

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最近更新
            </h3>
            <p className="text-sm text-foreground-500 mt-1">最新韩漫章节持续更新中</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="relative aspect-[5/7] rounded-lg overflow-hidden mb-2 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2">
                  <p className="text-xs text-white">
                    更新至第{comic.chapters}话
                  </p>
                </div>
              </div>
              <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h4>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.updateTime}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}